import ChildListPage from '@/modules/parent/childlist-page'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'

const ParentChildrenList = () => {
    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/parent/children-list']}>
            <ChildListPage />
        </ProtectedPage>
    )
}

export default ParentChildrenList
